import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import webSocketService from './websocketService';

const WebSocketContext = createContext();

export const WebSocketProvider = ({ children, requestId, sellerCompanyId }) => {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (requestId || sellerCompanyId) {
      webSocketService.connect(requestId, sellerCompanyId);
      setConnected(true);

      return () => {
        webSocketService.disconnect();
        setConnected(false);
      };
    }
  }, [requestId, sellerCompanyId]);

  const contextValue = useMemo(() => ({ connected, webSocketService }), [connected]);

  return (
    <WebSocketContext.Provider value={contextValue}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);

